import { getWebPath } from '@doss/common-all'
import { cn } from '~/@/lib/utils'
import { BreadcrumbObjectType, Table } from '~/common/generated/apollo-operations'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import Link from '~/components/shared/Link'

interface OverwriteLookupBannerProps {
  error: boolean
  header: string
  lookupTable: Pick<Table, 'id' | 'name'> & { parentTable?: { id: string } | null }
}

/**
 * Renders the banner in the lookup row options list when the user has selected to overwrite
 * the lookup
 */
export function OverwriteLookupBanner({ error, header, lookupTable }: OverwriteLookupBannerProps) {
  const { t } = useTypedTranslation()
  return (
    <div
      className={cn(
        error ? 'bg-red-2 border-s border-red-9' : 'bg-blue-2 border-s border-blue-9',
        'p-4 flex flex-col gap-2 w-full h-fit',
      )}
    >
      <div className="">{header}</div>
      <div>
        {t('record.lookup.add_item_in_table')}{' '}
        <Link
          href={getWebPath({
            objectType: BreadcrumbObjectType.TABLE,
            objectId: lookupTable.id,
          })}
          target="_blank"
        >
          {lookupTable.name}
        </Link>
      </div>
    </div>
  )
}
